import { render, staticRenderFns } from "./ProductSliderCard.vue?vue&type=template&id=3652cf58&"
import script from "./ProductSliderCard.vue?vue&type=script&lang=js&"
export * from "./ProductSliderCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductSliderCard.vue?vue&type=style&index=0&id=3652cf58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VImg,VSpacer})
